import events from "events"

export class TEvent<T> {
    constructor() {
        this.emitter.setMaxListeners(Infinity);
    }
    emitter = new events.EventEmitter();
    EVENT_NAME = Symbol();
    register(cb: (item: T) => void): void {
        this.emitter.on(this.EVENT_NAME, cb);
    }
    unregister(cb: (item: T) => void): void {
        this.emitter.removeListener(this.EVENT_NAME, cb);
    }
    emit(item: T): void {
        this.emitter.emit(this.EVENT_NAME, item);
    }
}

export class Event {
    constructor() {
        this.emitter.setMaxListeners(Infinity);
    }
    private emitter = new events.EventEmitter();
    private EVENT_NAME = Symbol();
    onfirstregistration = () => { };
    onlastunregistration = () => { };
    register(cb: () => void): void {
        this.emitter.on(this.EVENT_NAME, cb);
        if (this.emitter.listeners(this.EVENT_NAME).length === 1) {
            this.onfirstregistration();
        }
    }
    unregister(cb: () => void): void {
        this.emitter.removeListener(this.EVENT_NAME, cb);
        if (this.emitter.listeners(this.EVENT_NAME).length === 0) {
            this.onlastunregistration();
        }
    }
    emit(): void {
        this.emitter.emit(this.EVENT_NAME);
    }
}